import { createFileRoute } from '@tanstack/react-router';
import { SEO } from '@/components/SEO';
import { TrustLayerDemo } from '@/components/poc/TrustLayerDemo';

function TrustRoute() {
  return (
    <>
      <SEO
        title='Trust layer POC'
        description='Timestamps, unalterable-record chips, and a ship log audit tape.'
        path='/poc/trust'
        noindex
      />
      <TrustLayerDemo />
    </>
  );
}

export const Route = createFileRoute('/poc/trust')({
  component: TrustRoute,
});
